import { dictionary, Language } from "../utils/dictionary";
import { useAuth } from "../context/AuthContext";
import { ConfigurationPanel } from "../components/preferences/ConfigPanel";
import { LanguageSwitcher } from "../components/LanguageSwitcher";

export default function UserPreferences() {
  const { language, setLanguage } = useAuth();

  const handleChangeLanguage = (lang: Language) => {
    setLanguage(lang);
  };

  return (
    <div className="fixed inset-0 z-[9999] bg-[#F5F6FA] font-['Plus_Jakarta_Sans',sans-serif] text-center overflow-y-auto">
      {/* Background Gradient - Fixed to cover entire viewport */}
      <div
        className="fixed inset-0 z-0 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(62, 62, 255, 0) 0%, rgba(62, 110, 255, 0.2) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",
        }}
      />

      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center container mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 md:py-10 lg:py-12">
        <div className="w-full flex flex-col lg:flex-row items-center justify-center gap-6 sm:gap-8 md:gap-12 lg:gap-24">
          {/* Left Side: Welcome & Logo */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left max-w-md w-full lg:w-auto animate-in slide-in-from-left duration-500">
            <div className="relative w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 mb-3 sm:mb-4">
              <img
                src="https://fluxi.s3.amazonaws.com/prod/assets/images/fluxi-head"
                alt="Fluxi Logo"
                className="w-full h-full object-contain"
              />
            </div>

            <div className="space-y-2 sm:space-y-3">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium text-slate-900 leading-tight">
                {dictionary["welcome-to"][language]}{" "}
                <br className="hidden sm:block" />
                <img
                  src="https://fluxi.s3.amazonaws.com/prod/assets/fluxi/fluxi-logo.svg"
                  alt="Fluxi"
                  className="inline-block h-6 sm:h-7 md:h-8 lg:h-10 mt-1 sm:mt-2"
                />
              </h1>
              <p className="text-sm sm:text-base md:text-lg text-slate-600 max-w-xs mx-auto lg:mx-0 leading-relaxed pt-3 sm:pt-4 px-2 sm:px-0">
                {
                  dictionary["configure-your-account-in-a-few-moments"][
                  language
                  ]
                }
              </p>
            </div>
          </div>

          {/* Right Side: The Wizard Panel */}
          <div className="absolute top-6 right-6 z-50">
            <LanguageSwitcher
              currentLanguage={language}
              languages={Object.values(Language)}
              onChangeLanguage={handleChangeLanguage}
            />
          </div>
          <div className="w-full lg:w-auto flex-shrink-0">
            <ConfigurationPanel />
          </div>
        </div>
      </div>
    </div>
  );
}
